import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'nf-date-slider',
  templateUrl: './date-slider.component.html',
  styleUrls: ['./date-slider.component.css']
})
export class DateSliderComponent implements OnInit {

  dateAreaWidth;
  dateSection = [];
  dateSectionStart: Date;
  dateSectionEnd: Date;
  sectionUnit; // 单位长度
  startDate: Date;
  endDate: Date;
  startDateForShow: Date;
  endDateForShow: Date;
  startPos; // 滑块起始位置
  endPos; // 滑块结束为止
  cacheX = 0;
  buttonWidth = 200; // 滑块宽度
  left = 0; // 滑块距离左边的像素
  scale = 0; // 放大规模，默认展示8周 0--8周，1--16周 2--8月 3--16月
  dayMs = 24 * 60 * 60 * 1000;// 一天的毫秒数
  weekFormat = 'MM月dd';
  monthFormat = 'MM月';
  dayCount; // 当前scale下，显示的总天数
  mouseDownFlag = false;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dateAreaWidth = document.getElementById('date-area').clientWidth;
      this.buttonWidth = this.dateAreaWidth / 8;
      this.calculateDateSection();
    }, 100);
    const today = new Date();
    const day = today.getDay(); // 今天是周几
    let ms = (day + 6) % 7 * this.dayMs;
    this.startDate = new Date(today.valueOf() - ms);
    this.endDate = new Date(this.startDate.valueOf() + 6 * this.dayMs);
    this.startDateForShow = new Date(this.startDate.valueOf());
    this.endDateForShow = new Date(this.endDate.valueOf());
    this.emitData();
  }

  calculateDateSection() {
    this.dateSection = [];
    const today = new Date();
    const day = today.getDay(); // 今天是周几
    let ms = (day + 6) % 7 * this.dayMs;
    let date: Date;
    let startMs;
    switch (this.scale) {
      case 0: // 8周
        startMs = today.valueOf() - 4 * 7 * this.dayMs - ms;
        date = new Date(startMs);
        this.dateSectionStart = new Date(startMs);
        for (let i = 0; i < 8; i++) {
          this.dateSection.push(this.datePipe.transform(date, this.weekFormat));
          date.setDate(date.getDate() + 7);
        }
        this.dateSectionEnd = new Date(date.valueOf() - this.dayMs);
        break;
      case 1: // 16周
        startMs = today.valueOf() - 8 * 7 * this.dayMs - ms;
        date = new Date(startMs);
        this.dateSectionStart = new Date(startMs);
        for (let i = 0; i < 16; i++) {
          this.dateSection.push(this.datePipe.transform(date, this.weekFormat));
          date.setDate(date.getDate() + 7);
        }
        this.dateSectionEnd = new Date(date.valueOf() - this.dayMs);
        break;
      case 2: // 8个月
        today.setMonth(today.getMonth() - 4);
        today.setDate(1);
        this.dateSectionStart = new Date(today);
        for (let i = 0; i < 8; i++) {
          this.dateSection.push(this.datePipe.transform(today, this.monthFormat));
          today.setMonth(today.getMonth() + 1);
        }
        today.setMonth(today.getMonth() - 1);
        today.setDate(this.getMonthLastDay(today));
        this.dateSectionEnd = new Date(today);
        break;
      case 3: // 16个月
        today.setMonth(today.getMonth() - 8);
        today.setDate(1);
        this.dateSectionStart = new Date(today);
        for (let i = 0; i < 16; i++) {
          this.dateSection.push(this.datePipe.transform(today, this.monthFormat));
          today.setMonth(today.getMonth() + 1);
        }
        today.setMonth(today.getMonth() - 1);
        today.setDate(this.getMonthLastDay(today));
        this.dateSectionEnd = new Date(today);
        break;
    }
    this.dayCount = this.getYearDay(this.dateSectionEnd) - this.getYearDay(this.dateSectionStart) + 1;
    if (this.startDate.valueOf() < this.dateSectionStart.valueOf()) {
      this.startDate = this.dateSectionStart;
    }
    if (this.endDate.valueOf() > this.dateSectionEnd.valueOf()) {
      this.endDate = this.dateSectionEnd;
    }
    this.zeroTime();
    this.sectionUnit = this.dateAreaWidth / this.dayCount;
    this.buttonWidth = this.getButtonWidth();
    this.left = (this.getYearDay(this.startDate) - this.getYearDay(this.dateSectionStart)) * this.dateAreaWidth/ this.dayCount;
  }

  // 分、秒、毫秒 归零
  zeroTime() {
    this.startDate.setMinutes(0, 0, 0);
    this.endDate.setMinutes(0,0,0);
    this.dateSectionStart.setMinutes(0,0,0);
    this.dateSectionEnd.setMinutes(0,0,0);
  }

  buttonMoving(event) {
    let x = event.distance.x; // 拖动距离
    let absX = Math.abs(event.distance.x);
    if (absX >= this.sectionUnit) {
      const days = (x - x % this.sectionUnit)/this.sectionUnit; // 移动天数
      if (!this.moveAllowed(days)) {
        event.source.element.nativeElement.style.transform = '';
        return;
      }
      this.startDateForShow = new Date(this.startDate.valueOf() + this.dayMs * days);
      this.endDateForShow = new Date(this.endDate.valueOf() + this.dayMs * days);
      this.left = this.getLeft(this.startDateForShow);
    }
    event.source.element.nativeElement.style.transform = '';
  }

  buttonMoveEnd(event) {
    let x = event.distance.x; // 拖动距离
    let absX = Math.abs(event.distance.x);
    if (absX > this.sectionUnit) {
      const days = (x - x % this.sectionUnit)/this.sectionUnit; // 移动天数
      const startTemp = new Date(this.startDate.valueOf() + this.dayMs * days);
      const endTemp = new Date(this.endDate.valueOf() + this.dayMs * days);
      if (startTemp.valueOf() < this.dateSectionStart.valueOf()) { // 超过左边界
        this.startDate = this.dateSectionStart;
        this.endDate = new Date(this.startDate.valueOf() + this.buttonWidth / this.sectionUnit * this.dayMs);
      } else if (endTemp.valueOf() > this.dateSectionEnd.valueOf()) { // 超过右边界
        this.endDate = this.dateSectionEnd;
        this.startDate = new Date(this.endDate.valueOf() - this.buttonWidth / this.sectionUnit * this.dayMs);
      } else { // 在中间移动
        this.startDate = new Date(this.startDate.valueOf() + this.dayMs * days);
        this.endDate = new Date(this.endDate.valueOf() + this.dayMs * days);
      }
      this.left = this.getLeft(this.startDate);
      this.startDateForShow = new Date(this.startDate.valueOf());
      this.endDateForShow = new Date(this.endDate.valueOf());
      this.emitData();
    }
    event.source.element.nativeElement.style.transform = '';
  }

  moveAllowed(days): boolean {
    const startTemp = new Date(this.startDate.valueOf() + this.dayMs * days);
    const endTemp = new Date(this.endDate.valueOf() + this.dayMs * days);
    return !(startTemp.valueOf() < this.dateSectionStart.valueOf() || endTemp.valueOf() > this.dateSectionEnd.valueOf());
  }

  mouseMoved(target, event) {
    let x = event.distance.x; // 拖动距离
    let absX = Math.abs(event.distance.x);
    const days = (x - x % this.sectionUnit)/this.sectionUnit; // 移动天数
    if (absX >= this.sectionUnit) {
      const startTemp = new Date(this.startDate.valueOf() + this.dayMs * days);
      const endTemp = new Date(this.endDate.valueOf() + this.dayMs * days);
      if (target == 'left' && startTemp.valueOf() < this.endDateForShow.valueOf()) { // 拖动左侧按钮
        this.buttonWidth = this.getButtonWidth() - days * this.sectionUnit;
        this.startDateForShow = new Date(this.startDate.valueOf() + this.dayMs * days);
        this.left = this.getLeft(this.startDate) + days * this.sectionUnit;
      } else if (target == 'right' && endTemp.valueOf() > this.startDateForShow.valueOf()) { // 拖动右侧按钮
        this.buttonWidth = this.getButtonWidth() + days * this.sectionUnit;
        this.endDateForShow = new Date(this.endDate.valueOf() + this.dayMs * days);
      }
    }
    event.source.element.nativeElement.style.transform = '';
  }

  dragEnd(target,event) {
    let x = event.distance.x;
    let absX = Math.abs(event.distance.x);
    if (absX >= this.sectionUnit) {
      const days = (x - x % this.sectionUnit)/this.sectionUnit; // 移动天数
      if (target == 'left') {
        this.startDate = new Date(this.startDate.valueOf() + days * this.dayMs);
        if (this.startDate.valueOf() < this.dateSectionStart.valueOf()) {
          this.startDate = this.dateSectionStart;
        } else if (this.startDate.valueOf() > this.endDate.valueOf()) {
          this.startDate = this.endDate;
        }
        this.left = this.getLeft(this.startDate);
      } else {
        this.endDate = new Date(this.endDate.valueOf() + days * this.dayMs);
        if (this.endDate.valueOf() > this.dateSectionEnd.valueOf()) {
          this.endDate = this.dateSectionEnd;
        } else if (this.endDate.valueOf() < this.startDate.valueOf()) {
          this.endDate = this.startDate;
        }
      }
      if (this.startDate.valueOf() > this.endDate.valueOf()) { // 交换位置
        const temp = this.endDate;
        this.endDate = this.startDate;
        this.startDate = temp;
      }
      this.buttonWidth = this.getButtonWidth();
      this.emitData();
    }
    this.startDateForShow = new Date(this.startDate.valueOf());
    this.endDateForShow = new Date(this.endDate.valueOf());
    event.source.element.nativeElement.style.transform = '';
  }

  emitData() {
    const format = 'yyyy-MM-dd';
    this.valueChange.emit([this.datePipe.transform(this.startDate, format), this.datePipe.transform(this.endDate, format)]);
  }

  getButtonWidth(): number {
    return (this.getYearDay(this.endDate) - this.getYearDay(this.startDate) + 1) / this.dayCount * this.dateAreaWidth;
  }

  getLeft(startDate: Date):number {
    return (this.getYearDay(startDate) - this.getYearDay(this.dateSectionStart)) * this.dateAreaWidth/ this.dayCount;
  }

  scaleExpend() {
    if (this.scale < 3) {
      this.scale++;
      this.calculateDateSection();
    }
  }

  scaleReduce() {
    if (this.scale > 0) {
      this.scale--;
      this.calculateDateSection();
    }
  }

  getYearDay(date: Date) { // 日期是一年中的第几天
    return Math.ceil(( date.valueOf() - new Date(date.getFullYear()).valueOf())/(24*60*60*1000))+1;
  }

  getMonthLastDay(date: Date):number { // 某月的最后一天
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
      return 31;
    } else if (month == 4 || month ==6 || month ==9 || month ==11){
      return 30;
    } else {
      return ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0)? 29: 28;
    }
  }
}
